import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import { routes } from 'routes'
import DashboardLayout from 'Layout'
import ProtectedRoute from 'components/ProtectedRoute'

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route element={<DashboardLayout />}>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                route.requireAuth ? (
                  <ProtectedRoute>{route.element}</ProtectedRoute>
                ) : (
                  route.element
                )
              }
            />
          ))}
        </Route>
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
